// Module
var code = "<script>let $ctrl</script> <molecule-panel-view include-show-all-link=\"false\" include-show-details-link=\"false\" panel-icon=\"sliders-h\" panel-items-horizontal=\"true\" panel-items=\"$ctrl.linkList\" panel-title=\"{{ 'TR_100119-a22157_TR' | translate }}\"></molecule-panel-view> ";
// Exports
module.exports = code;